<ion-header>
  <ion-toolbar>
    <ion-title>{{this.translate.instant('151')}}</ion-title>
    <ion-button mode='ios' slot="end" (click)="close()" fill="clear">
      <ion-icon slot="icon-only" name="close-circle-outline" color="primary"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-row>
    <ion-col text-center>
      <form [formGroup]="formDoCopiaListino" (ngSubmit)="doCopiaListino()">
        <ion-item>
          <ion-label>{{this.translate.instant('152')}}</ion-label>
          <ion-input labelPlacement="stacked" type="text" formControlName="cod_listino"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>{{this.translate.instant('153')}}</ion-label>
          <ion-input labelPlacement="stacked" type="text" formControlName="des_listino"></ion-input>
        </ion-item>
      </form>
    </ion-col>
  </ion-row>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar class="ion-text-center">
    <ion-button mode='ios' type="submit" [disabled]="!formDoCopiaListino.valid" (click)="doCopiaListino()" color="primary">{{this.translate.instant('123')}}</ion-button>
  </ion-toolbar>
</ion-footer>
